import INFTCollections from '../../models/INFTCollections'
import ChillAFSlothsCard from '../../nftFormats/ChillAFSloths/Card/ChillAFSlothsCard'
import ChillAFSlothsDetail from '../../nftFormats/ChillAFSloths/Detail/ChillAFSlothsDetail'
import ChillAFSlothsctivtyDetail from '../../nftFormats/ChillAFSloths/Activity/ChillAFSlothsActivtyDetail'
import ChillAFSlothsLogo from '../../../../assets/nft-logo/ChillAFSlothsLogo.png'

export const ChillAFSlothsData: INFTCollections = {
  id: 'chillafsloths',
  tokenAddress: '0x2651570B937B5E39ADA9119C8A284A7DF5bd8701',
  name: 'Chill AF Sloths',
  cardFormat: ChillAFSlothsCard,
  detailFormat: ChillAFSlothsDetail,
  activityFormat: ChillAFSlothsctivtyDetail,
  category: 1,
  creatorAddress: '0x6c178d3231EcE7C06cfc223265376F5985557f2f',
  logo: ChillAFSlothsLogo,
  website: 'https://chillafsloths.com/',
  twitter: 'ChillAFsloths',
  discord: 'https://discord.com/invite/V8MdK8v7eD'
}

export const ChillAFSlothsCategoryData = {
  [ChillAFSlothsData.tokenAddress.toLowerCase()]: ChillAFSlothsData.category
}
